/**
 * useStreamMetering — streaming session timing and quota state
 * Phase 4 (PRI-291): extracted from useStreamSession
 *
 * Owns: elapsed_s, session_remaining_s, daily_remaining_s, daily_used_s
 * Setters are returned to the orchestrator (useStreamSession) for the WS handler to call.
 */

import { useState, useRef, useEffect } from 'react'
import type { StreamMeteringState } from '../../hooks/types'

export const INITIAL_METERING: StreamMeteringState = {
  elapsed_s: 0,
  session_remaining_s: 60,
  daily_remaining_s: 600,
  daily_used_s: 0,
}

export interface StreamMeteringReturn {
  metering: StreamMeteringState
  setMetering: React.Dispatch<React.SetStateAction<StreamMeteringState>>
  meteringRef: React.MutableRefObject<StreamMeteringState>
  resetMetering: () => void
}

export function useStreamMetering(): StreamMeteringReturn {
  const [metering, setMetering] = useState<StreamMeteringState>(INITIAL_METERING)
  const meteringRef = useRef<StreamMeteringState>(INITIAL_METERING)

  useEffect(() => {
    meteringRef.current = metering
  }, [metering])

  const resetMetering = () => setMetering(INITIAL_METERING)

  return { metering, setMetering, meteringRef, resetMetering }
}
